import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { ProdottiModule } from '../layout/components/prodotti/prodotti.module';
import { RouterModule } from '@angular/router';
import { ElencoProdottiComponent } from './elenco-prodotti.component';
import {MatTreeModule} from '@angular/material/tree';
import {MatIconModule} from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { Prodotti2Module } from '../layout/components/prodotti2/prodotti2.module';

@NgModule({
  declarations: [ElencoProdottiComponent],
  imports: [
    CommonModule,
    NgbModule,
    HttpClientModule,
    Prodotti2Module,
    MatTreeModule,
    MatIconModule,
    FormsModule,
    RouterModule.forChild([
      {
        path: '',
        component: ElencoProdottiComponent,
      },
    ]),
  ]
})
export class ElencoProdottiModule { }
